export default "__VITE_ASSET__CAGSwKhn__"